import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class PointsApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "points/";
	}

	async changeValue(point, key, newValue, unmanage, onSuccess, onError) {
		let response;
        try {
            response = await fetch((point + "change_value/").replace("client_id", this.getClientID()),
                {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.getToken()
                    },
                    body: JSON.stringify(
                        {
                            "key": key,
                            "value": newValue,
                            "unmanage": unmanage
                        }
                    ),
                }
            )
        } catch (err) {
            onError({ "non_field_errors": "Problem connecting with server." });
            return;
        }

        if (response.ok) {
            onSuccess();
        } else if (response.status === 400) {
            onError();
        } else if (response.status === 401) {
            this.onUnauthorized()
        } else {
            onError({ "non_field_errors": "Unexpected problem when trying to change value." });
        }
	}
}
